import { type JSX } from 'react';
import { twMerge } from 'tailwind-merge';

import {
    SelectIcon,
    SelectInput,
    SelectInputContent,
    SelectInputItem,
    SelectInputProps,
    Label,
} from '@videoblocks/design-system';

import { SelectOption } from '../../_context/constants';

export type SelectFieldProps = SelectInputProps & {
    label: string;
    id: string;
    options: SelectOption[];
    className?: string;
    triggerClassName?: string;
};

export const SelectField = ({
    label,
    id,
    options,
    className,
    triggerClassName,
    selectTriggerProps = {},
    ...rest
}: SelectFieldProps): JSX.Element => {
    return (
        <div className={twMerge('flex flex-col gap-2 w-full', className)}>
            <Label htmlFor={id} className="text-left" fontSize="sm">
                {label}
            </Label>
            <SelectInput
                iconSuffix={<SelectIcon />}
                className={triggerClassName}
                selectTriggerProps={{ id, ...selectTriggerProps }}
                {...rest}
            >
                <SelectInputContent align="start">
                    {options.map((option) => (
                        <SelectInputItem key={option.value} value={option.value}>
                            <span>{option.label}</span>
                        </SelectInputItem>
                    ))}
                </SelectInputContent>
            </SelectInput>
        </div>
    );
};
